import React from 'react';

import * as Misc from './../../misc';

export default ({handleAddQuoteClick}) => (
  <div className="review-submit-stone-listitemrenderer-blank" onClick={e => Misc.ignore(e, () => handleAddQuoteClick())}>
    <div className="review-submit-stone-button-wrapper">
      <div className="review-submit-stone-button">
        <div className="review-submit-stone-button-icon"/>
        Add Countertop
      </div>
    </div>
  </div>
);




// WEBPACK FOOTER //
// ./src/components/projectSummary/newQuoteElement.js